// Lightweight SEO helper: sets document.title, meta name/property tags and canonical link.
// Returns a cleanup function that restores defaults.
const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (content) {
    if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
    el.setAttribute('content', content);
  } else if (el) { el.remove(); }
};

const setCanonical = (href) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (href) {
    if (!el) { el = document.createElement('link'); el.setAttribute('rel', 'canonical'); document.head.appendChild(el); }
    el.setAttribute('href', href);
  } else if (el) { el.remove(); }
};

export function applySeo({ title, description, keywords, canonical, ogTitle, ogDescription, ogImage, ogType = 'article' } = {}) {
  if (title) document.title = title;
  setMeta('name', 'description', description);
  setMeta('name', 'keywords', keywords);
  // Always expose a canonical URL — default to the current clean URL when not provided.
  const canonicalHref = canonical || (typeof window !== 'undefined' ? window.location.origin + window.location.pathname : '');
  setCanonical(canonicalHref);
  setMeta('property', 'og:title', ogTitle || title);
  setMeta('property', 'og:description', ogDescription || description);
  setMeta('property', 'og:image', ogImage);
  setMeta('property', 'og:url', canonicalHref);
  setMeta('property', 'og:type', ogType);
  return () => {
    document.title = 'Gaze Decor';
    setMeta('name', 'description', '');
    setMeta('name', 'keywords', '');
    setCanonical('');
    setMeta('property', 'og:title', '');
    setMeta('property', 'og:description', '');
    setMeta('property', 'og:image', '');
    setMeta('property', 'og:url', '');
    setMeta('property', 'og:type', '');
  };
}
